module.exports = __webpack_public_path__ + "static/media/g5.68772441.png";